<template>
  <form :class="{'needs-validation': validated}">
    <slot />
  </form>
</template>

<script>
export default {
  data: () => ({ validated: false }),
  expose: ['validate'],
  methods: {
    validate() {
      this.validated = true;
      return this.$el.checkValidity();
    },
  },
};
</script>
